import { useState, useEffect } from "react";
import { useRaspStore } from "../store/raspStore";
import { examdetailsService } from "../services/ExamDetailsService";

export const useExamdetailsViewModel = (userId: string, appId: string) => {
    const [fields, setFields] = useState<any[]>([]);
    const [foreignKeyData, setForeignKeyData] = useState<any>({});
    const [enums, setEnums] = useState<any>({});
    const [dataToSave, setDataToSave] = useState<any>({});
    const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(new Set());
    const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(new Set());

    const addSubmission = useRaspStore((s) => s.addSubmission);
    const getSubmissions = useRaspStore((s) => s.getSubmissions);
    const getUserAllData = useRaspStore((s) => s.getUserAllData);

    useEffect(() => {
        const dataFromStore = getSubmissions(userId, "Examdetails");
        const allData = getUserAllData(userId);
        console.log("exam details store data", dataFromStore, allData);
    }, []);

    // ✅ Load metadata
    const loadMetadata = async () => {
        const metadata = await examdetailsService.getMetadata();
        const metaFields = metadata[0].fieldValues || [];

        setFields(metaFields);

        // ✅ Foreign keys
        for (let field of metaFields) {
            if (field.foreign) {
                const foreignName = field.foreign;

                if (!fetchedForeign.has(foreignName)) {
                    const updated = new Set(fetchedForeign);
                    updated.add(foreignName);
                    setFetchedForeign(updated);

                    const data =
                        await examdetailsService.getForeignResource(foreignName);

                    setForeignKeyData((prev: any) => ({
                        ...prev,
                        [foreignName]: data,
                    }));
                }
            }
        }

        // ✅ Enums
        for (let field of metaFields) {
            if (field.isEnum) {
                const enumName = field.possible_value;

                if (!fetchedEnum.has(enumName)) {
                    const updatedEnum = new Set(fetchedEnum);
                    updatedEnum.add(enumName);
                    setFetchedEnum(updatedEnum);

                    const values = await examdetailsService.getEnum(enumName);

                    setEnums((prev: any) => ({
                        ...prev,
                        [enumName]: values,
                    }));
                }
            }
        }
    };

    
    // ✅ SAVE
    const save = async (extraData: any = {}) => {
        const params = new FormData();
        const payloadToSave = { ...dataToSave, ...extraData };
        // const payloadToSave = { ...extraData };
        // ✅ Normalize empty values → null
        Object.keys(payloadToSave).forEach((key) => {
            if (payloadToSave[key] === "") {
                payloadToSave[key] = null;
            }
        });

        // ✅ Handle files
        const fileKeys = Object.keys(payloadToSave).filter(
            (key) => payloadToSave[key] instanceof File
        );

        if (fileKeys.length > 0) {
            fileKeys.forEach((key) => {
                params.append(key, payloadToSave[key]);

                // clear file from JSON payload
                payloadToSave[key] = "";
            });

            params.append("description", "application-gate");
            params.append("appId", "admission-portal");
            params.append("dmsRole", "admin");
            params.append("user_id", userId);
            params.append("tags", "t1,t2,attend,gate");
        }
        console.log("payloadToSave", dataToSave)

        // ✅ Encode payload
        const jsonString = JSON.stringify(payloadToSave);

        const base64Encoded = btoa(
            encodeURIComponent(jsonString).replace(
                /%([0-9A-F]{2})/g,
                (_, p1) => String.fromCharCode(parseInt(p1, 16))
            )
        );

        // if (payloadToSave.id) {
        //     params.append("action", "MODIFY");
        // }

        params.append("resource", base64Encoded);

        const response = await examdetailsService.create({
            params,
        });

        if(response.errCode === -1) {
            return;
        }
        if (response.errCode !== -1) {
            addSubmission(userId, "Student", payloadToSave);

            console.log(
                "exam details stored",
                getUserAllData(userId)
            );
        }
    };

    return {
        fields,
        setFields,
        enums,
        setEnums,
        foreignKeyData,
        setForeignKeyData,
        dataToSave,
        setDataToSave,
        loadMetadata,
        save,
    };
};